import React, { useRef, useState } from 'react';
import { Box } from '@mui/material';
import { colors } from '../../theme/colors';

export default function EmailCodeInput({ value, onChange, disabled, label, error, descriptionId }) {
  const input = useRef(null);
  const [focused, setFocused] = useState(false);
  return <Box sx={{ position: 'relative', width: 256, maxWidth: '100%' }}>
    <Box aria-hidden="true" sx={{ display: 'flex', gap: 1 }}>
      {Array.from({ length: 6 }, (_, index) => <Box key={index} sx={{
        width: 36, height: 36, flex: '1 1 0', display: 'grid', placeItems: 'center',
        border: `1px solid ${error ? colors.Error[600] : '#e6e6e6'}`, borderRadius: '22px',
        bgcolor: 'rgba(230, 230, 230, 0.5)', fontSize: 16, color: colors.Grey[900],
        outline: focused && Math.min(value.length, 5) === index ? `2px solid ${colors.Primary[800]}` : undefined,
        outlineOffset: 2,
      }}>{value[index] || ''}</Box>)}
    </Box>
    <Box component="input" ref={input} autoFocus value={value} disabled={disabled} aria-label={label}
      aria-invalid={Boolean(error)} aria-describedby={descriptionId} inputMode="numeric" autoComplete="one-time-code" maxLength={6}
      onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
      onChange={(event) => onChange(event.target.value.replace(/\D/g, '').slice(0, 6))}
      onPaste={(event) => {
        const digits = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
        if (digits) { event.preventDefault(); onChange(digits); }
      }}
      sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 0, cursor: 'text', fontSize: 16 }} />
  </Box>;
}
